import { Col, Row } from 'reactstrap';
import { Button } from '../../../common/components';

const GenerateTrustItems = ({ title, description, generateTable }) => {
  return (
    <Row className="generate-trust">
      <Col lg={6} className="generate-trust-item">
        <Row>
          <Col lg="8" className="generate-label">
            <h1 className="trust-heading">{title}</h1>
            <p className="trust-description">{description}</p>
          </Col>
        </Row>
      </Col>
      <Col lg={6}>
        <Row className="generate-card-item1">
          <Col className="generate-button">
            <Button onClick={() => generateTable('click')} color="primary">
              Generate
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default GenerateTrustItems;
